import axios from "axios";
import { City, Country, Location } from "../interfaces/country.interface";

class LocationsApi {

  getCountries(): Promise<Country[]> {
    const apiUrl = "/api/v1/locations";

    return axios.get(apiUrl)
    .then(response => {
      const countries = response.data.map(locationData => {
        const countryData = locationData.data.attributes;
        const citiesData = countryData.children.map(childrenData => this.mapCity(childrenData.data.attributes));
        
        const allCities = [...citiesData];
        const citiesWithImages = allCities.filter(x => x.cover != null);
        const topCities = citiesWithImages.splice(0,4);
        const highlights = citiesWithImages.splice(0,5);
        
        const country:Country = {
          id: countryData.id,
          name: countryData.name,
          cover: countryData.cover,
          tourCount: countryData.itineraries,
          cities: allCities,
          topCities: topCities,
          highlights: highlights,
          tags: allCities.filter(city => !topCities.includes(city) && !highlights.includes(city)),
        }

        return country;
      })
      return Promise.resolve(countries);
    });
  }

  getLocation(locationId:number): Promise<Location> {
    const apiUrl = `/api/v1/locations/${locationId}`;


    return axios.get(apiUrl)
    .then(response => {
      const locationData = response.data.data.attributes;
      const location: Location = {
        id: locationData.id,
        cover: locationData.cover,
        name: locationData.name,
        ancestry: locationData.ancestors.map(a => {
          return {
            id: a.id,
            name: a.name
          }
        })
      }
      return Promise.resolve(location);
    });
  }

  private mapCity(cityData): City{
    const city:City = {
      id: cityData.id,
      name: cityData.name,
      cover: cityData.cover,
      tourCount: cityData.itineraries
    };
    return city;
  }

}

export default LocationsApi;